import React, { ChangeEvent, FC, useCallback } from 'react'
import styles from 'styles/components/card.module.scss'
import { MailType, PermissionType, StaffType } from 'types/staff'
import { useDispatch } from 'react-redux'
import { toggleMails } from 'reducks/auth/operations'
import { ToggleRoundButton } from 'components/Form'

type Props = {
  label: string
  mail: MailType
  mails: MailType[]
  permission: PermissionType
  staff?: StaffType
  uid: string
}

const ReceiveCardListDetail: FC<Props> = (props) => {
  const { label, mail, mails, permission, staff, uid } = props
  const dispatch = useDispatch()

  const toggle = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const permission = event.target.id as PermissionType
      dispatch(toggleMails({ mails, permission, staff, uid }))
    },
    [dispatch, mails, staff, uid]
  )

  return (
    <div className={styles.list__detail}>
      <span>{label}</span>
      <ToggleRoundButton permission={permission} toggle={toggle} on={mail.permissions.includes(permission)} />
    </div>
  )
}

export default ReceiveCardListDetail
